export default __webpack_public_path__ + "static/media/8.2d0d9ed6.jpg";